import $ from 'jquery';
import {nanoid} from 'nanoid';
import CONSTANT from '../../common/js/_constant';
import searchResultTemplate from './searchResultItems.hbs';
import globalSearchResult from '../globalSearch/globalSearch';
import searchDataTemplate from './searchData.hbs';
import searchResultPagination from './searchResultPagination.hbs';
import searchResultShowTemplate from './searchResultShow.hbs';
import searchNoResult from './searchNoResult.hbs';

const searchResult = {
    variables:{
        searchWrapper:'.search__result--wrapper',
        searchFilterLabel:'.search__result__filter--box',
        searchFilterInput:'.search__result--filter',
        searchResultInput:'.search__result--input',
        searchResultListWrapper:'.search__result--list',
        searchDataWrapper:'.search__result__data--wrapper',
        searchResultForm:'.search__result--form',
        searchResultListItem:'.global__search__result--item',
        searchSubmitBtn:'.search__submit',
        searchResultFilter:'.search__result--filter',
        searchPaginationNext:'.search__result__pagination--next',
        searchPaginationPrev:'.search__result__pagination--prev',
        searchPaginationContainer:'.search__result__pagination--container',
        searchPaginationCount:'.search__result__pagination--count',
        searchAllResult:'.all-result',
        searchKeyEvent:'.key-event',
        searchKeyContainer:'.search__result__key--container',
        searchKeyTitle:'.search__result__key--title',
        searchKeyBox:'.search__result__key--col',
        searchResultOverlay:'.search__result--overlay',
        searchResultNotFoundContainer:'.search__result__not__found',
        searchResultNotFoundContent:'.search__result__not__found--content',
        searchResultNotFoundText:'.search__result__not__found--text',
        searchResultTextContent:'.search__result--text',
        searchCurrentPage:1,
        searchItemPage:10,
        searchShowContainer:'.search__result__show--container',
        searchResultKey:[],
        url:'/bin/search',
    },
    methods:{
        setFilterId:function(){
            const {searchFilterInput,searchFilterLabel} = searchResult.variables;
            $(searchFilterInput).each(function(_i,_e){
                const filterId = nanoid();
                $(this).prop('id', filterId);
                $(this).next(searchFilterLabel).prop('for', filterId);
            });
        },
        fetchData:function(url,path,searchText,suc=()=>{return;},filter="AllResults"){

            const queryParams = $.param({
                path,
                searchText,
                filter
            });
            $.ajax({
                url: `${url}?${queryParams}`,
                method: "POST",
            }).done((response) => {
                        suc(response);
                        return response;
            }).fail((_jqXHR, textStatus, errorThrown) => {
                console.error("AJAX request failed:", textStatus, errorThrown);
                return errorThrown;
            });
        },
        appendSearchAutoResult:function(response){
            const {searchResultListWrapper} = searchResult.variables;
            const $this = searchResult;
            if($this.methods.isObjectEmpty(response) && response?.results.length > 0){
                $(searchResultListWrapper).append(searchResultTemplate({
                    items:response?.results,
                    noResultFoundText:'No Result Found'
                }));
            }else{
                $(searchResultListWrapper).append(searchResultTemplate({
                    items:[],
                    noResultFoundText:'No Result Found'
                }));
            }
        },
        isObjectEmpty:function(obj){
                return Object.entries(obj).length !== 0;
        },
        appendSearchKey:function(inputVal){
            const { searchKeyTitle, searchKeyBox,searchResultListWrapper } = searchResult.variables;
            const searchText = inputVal;
            const matchedItems = []; // Array to hold matched items

            if (searchText.length > 0) {
                $(searchKeyBox).each(function() {
                    const $this = $(this);
                    const searchTitle = $this.find(searchKeyTitle).text();

                    // Check for a match
                    if (searchTitle.toLowerCase().indexOf(searchText.toLowerCase()) > -1) {
                        matchedItems.push({ title: searchTitle.trim() }); // Add matched item to the array
                    }
                });

                // Update the label with the count of visible search boxes
            }
        if(matchedItems.length > 0) {
            $(searchResultListWrapper).append(searchResultTemplate({
                items: matchedItems,
                noResultFoundText:'No Result Found'
            })); // Return the array of matched items
        }else{
            $(searchResultListWrapper).append(searchResultTemplate({
                items: [],
                noResultFoundText:'No Result Found'
            })); // Return the array of matched items
        }
        },
        searchOnInput:function(){
            const {variables} = searchResult;
            const {searchResultInput,url,searchResultListWrapper,searchAllResult,searchFilterInput,searchKeyEvent,searchResultOverlay} = variables;
            const {INPUT} = CONSTANT.eventsListners;
            const {debounce} = globalSearchResult.methods;
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $this = this;
            const debounceCall= debounce((inputVal)=>{
                const isKeyEvent = $(searchFilterInput).filter(':checked').hasClass(searchKeyEvent.substr(1)) || false;
                if(isKeyEvent){
                    $this.appendSearchKey(inputVal);
                    $(searchResultListWrapper).removeClass('d-none');
                    $(searchResultOverlay).removeClass('d-none');
                }
                else{
                const searchPath = $(searchFilterInput).filter(':checked').val();
                $this.fetchData(url,searchPath,inputVal,$this.appendSearchAutoResult);
                $(searchResultListWrapper).removeClass('d-none');
                $(searchResultOverlay).removeClass('d-none');
                }
            },300);
            $(searchResultInput).on(INPUT, function(){
                const searchText = $(this).val();
                $(searchResultListWrapper).empty();
                if(searchText.length >= 3){
                   debounceCall(searchText);
            }
            else{
                $(searchResultListWrapper).addClass('d-none');
            }
        });
        /* eslint-disable @typescript-eslint/no-this-alias */
        },
        handleAutoSuggestBlur:function(){
            const {searchResultListWrapper,searchResultOverlay} = searchResult.variables;
            const {CLICK} = CONSTANT.eventsListners;
            $(searchResultOverlay).on(CLICK, function(){
                const $this = $(this);
                $this.addClass('d-none');
                $(searchResultListWrapper).addClass('d-none');
            });
        },
        searchInputFocus:function(){
            const {searchResultInput} = searchResult.variables;
            const {INPUT,FOCUS} = CONSTANT.eventsListners;
            $(searchResultInput).on(FOCUS,function(){
            $(searchResultInput).trigger(INPUT);
        });
        },
        populateSearchText() {
            const { searchResultInput,url,searchAllResult,searchResultFilter,searchKeyEvent,searchFilterLabel,searchKeyBox } = searchResult.variables;
            const urlParams = new URLSearchParams(window.location.search);
            const searchText = urlParams.get('searchText') || '';
            $(searchResultInput).val(searchText);
            this.resetResult();
            const isKeyAction = this.activateKeyAction();
            if(isKeyAction){
                $(searchKeyEvent).prop('checked',true);
                $(searchKeyEvent).filter(':checked').next(searchFilterLabel).append(`<span class="search__count">[${$(searchKeyBox).filter(":visible").length}]</span>`);
            } else{
                $(searchAllResult).prop('checked',true);
                const searchPath = $(searchResultFilter).not(searchKeyEvent).filter(':checked').val();
                this.fetchData(url,searchPath,searchText,this.renderSearchData);
            }
        },
        submitSearchInput:function(){
            const {searchResultForm,searchResultInput,url,searchResultListWrapper,searchResultFilter,searchAllResult,searchKeyEvent,searchResultNotFoundContainer,searchResultNotFoundText} = searchResult.variables;
            const {SUBMIT} = CONSTANT.eventsListners;
            const $this = searchResult.methods;
            $(searchResultForm).on(SUBMIT,function(event){
                event.preventDefault();
                const $form = $(this);
                searchResult.methods.resetResult();
                const searchText = $form.find(searchResultInput).val() || '';
                const isAction = $(searchResultFilter).filter(":checked").hasClass(searchKeyEvent.substr(1));
                if(isAction) {
                 const isMatch = $this.activateKeyAction();
                 $(searchResultListWrapper).addClass('d-none');
                    if(!isMatch) {
                        $(searchResultNotFoundContainer).removeClass('d-none');
                        $(searchResultNotFoundText).append(searchNoResult({
                            searchText:$(searchResultInput).val(),
                        }));
                    }
                }
                else{
                const searchPath = $(searchResultFilter).not(searchKeyEvent).filter(":checked").val();
                searchResult.variables.searchCurrentPage = 1;
                $this.fetchData(url,searchPath,searchText,$this.renderSearchData);
                $(searchResultListWrapper).addClass('d-none');
                }
            });
        },
        renderPage:function(page,data){
            const {variables} = searchResult;
            const {searchResultForm} = variables;
            variables.searchItemPage = $(searchResultForm).data('per-page');
            const itemsPerPage = variables.searchItemPage;
            const startIndex = (page - 1) * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;
            const visibleCards= data.slice(startIndex, endIndex);
            return visibleCards;
        },
        renderPagination:function(data){
            const {variables} = searchResult;
            const {searchPaginationContainer,searchPaginationPrev,searchPaginationNext} = variables;
            const totalPages = Math.ceil(data.length / variables.searchItemPage);
            $(searchPaginationContainer).empty();
            let pagination=[];
            const maxButtons = 6;
            let start = Math.max(1,variables.searchCurrentPage - Math.floor(maxButtons / 2));
            let end = start + maxButtons - 1;

            if (end > totalPages) {
                end = totalPages;
                start = Math.max(1, end - maxButtons + 1);
            }

            for(let i = start; i<=end; i++){
                pagination.push({
                    currentPage : variables.searchCurrentPage,
                    pageNumber : i
                });
            }
            $(searchPaginationContainer).append(searchResultPagination({
                pagination:pagination
            }));
            $(searchPaginationPrev).prop('disabled', variables.searchCurrentPage === 1);
            $(searchPaginationNext).prop('disabled', variables.searchCurrentPage === totalPages);
            $(searchPaginationPrev).removeClass('d-none');
            $(searchPaginationNext).removeClass('d-none');
        },
        renderShowResult:function(visiblePage,totalPage){
            const {searchShowContainer} = searchResult.variables;
            $(searchShowContainer).empty();
            $(searchShowContainer).append(searchResultShowTemplate({
                items:visiblePage,
                totalPages: totalPage,
            }));
        },
        renderSearchData:function(response){
            const {variables,methods} = searchResult;
            const {searchDataWrapper,searchPaginationNext,searchPaginationPrev,searchPaginationCount,searchPaginationContainer,searchShowContainer,searchResultForm,searchResultFilter,searchKeyEvent,searchFilterLabel,searchResultNotFoundText,searchResultNotFoundContainer,searchResultInput} = variables;
            const searchDataEl =  $(searchDataWrapper);
            const {CLICK} = CONSTANT.eventsListners;
            methods.resetResult();
            const $this = searchResult.methods;
            if($this.isObjectEmpty(response) && response?.results.length > 0){
                const data = $this.renderPage(variables.searchCurrentPage,response?.results);
                $(searchResultFilter).not(searchKeyEvent).filter(':checked').next(searchFilterLabel).append(`<span class="search__count">[${response?.results.length}]</span>`);
                $this.renderPagination(response?.results);
                $this.renderShowResult(data.length,response?.results.length);
                searchDataEl.append(searchDataTemplate({
                    items:data,
                    defaultImage:$(searchResultForm).data('default-img'),
                    noResultFoundText:'No Result Found'
                }));
                $(searchPaginationNext).off(CLICK);
                $(searchPaginationPrev).off(CLICK);
                $(searchPaginationCount).off(CLICK);
                $(searchPaginationNext).on(CLICK,function(){
                    const totalPages = Math.ceil(response?.results.length / variables.searchItemPage);

                    if(variables.searchCurrentPage < totalPages){
                        variables.searchCurrentPage = variables.searchCurrentPage+1;
                        $this.renderSearchData(response);
                        $this.scrollToElement();
                    }
                });
                $(searchPaginationPrev).on(CLICK,function(){
                    if(variables.searchCurrentPage > 1){
                        variables.searchCurrentPage = variables.searchCurrentPage - 1;
                        $this.renderSearchData(response);
                        $this.scrollToElement();
                    }
                });
                $(searchPaginationCount).on(CLICK,function(){
                    const page = $(this).data('page');
                    variables.searchCurrentPage = page;
                    $this.renderSearchData(response);
                    $this.scrollToElement();
                });
            }
            else{
                $(searchResultNotFoundContainer).removeClass('d-none');
                $(searchResultNotFoundText).append(searchNoResult({
                    searchText:$(searchResultInput).val(),
                }));
            }
        },
        handleAutoSuggestClick:function(){
            const {searchResultListWrapper,searchResultListItem,searchResultInput,searchResultForm} = searchResult.variables;
            const {CLICK,SUBMIT} = CONSTANT.eventsListners;
            $(searchResultListWrapper).on(CLICK, searchResultListItem, function(){
                const searchText = $(this).text().trim();
                $(searchResultInput).val(searchText);
                $(searchResultListWrapper).addClass('d-none');
                $(searchResultForm).trigger(SUBMIT);
            });
        },
        handleSubmitBtn:function(){
            const {searchResultForm,searchSubmitBtn} = searchResult.variables;
            const {CLICK,SUBMIT} = CONSTANT.eventsListners;
            $(searchResultForm).find(searchSubmitBtn).on(CLICK,function(event){
                $(searchResultForm).trigger(SUBMIT);
            });
        },
        handleChangeFilter:function(){
            const {searchResultFilter,searchResultForm,searchKeyEvent} = searchResult.variables;
            const {CHANGE,SUBMIT} = CONSTANT.eventsListners;
            const {activateKeyAction,resetResult} = this;
            $(searchResultFilter).on(CHANGE, function(){
                resetResult();
                $(searchResultForm).trigger(SUBMIT);
            });
        },
        scrollToElement:function(){
                const $target = $('.search__result__cards--container');
                if ($target.length) { // Check if the element exists
                    $('html, body').animate({
                        scrollTop: $target.offset().top // Get the top position of the target element
                    }, 400); // Duration in milliseconds
                }
        },
        activateKeyAction:function(){
            const {searchResultInput,searchKeyContainer,searchKeyTitle,searchKeyBox,searchKeyEvent,searchFilterLabel} = searchResult.variables;
            const searchText = $(searchResultInput).val();
            let isMatch = false;
            if(searchText.length > 0 ){
                $(searchKeyBox).each(function(){
                    const $this = $(this);
                    const searchTitle = $this.find(searchKeyTitle).text();
                    if(searchTitle.toLowerCase().indexOf(searchText.toLowerCase()) > -1){
                        $this.removeClass('d-none');
                        isMatch = true;
                    }else{
                        $this.addClass('d-none');

                    }
                });
                $(searchKeyEvent).filter(':checked').next(searchFilterLabel).append(`<span class="search__count">[${$(searchKeyBox).filter(":visible").length}]</span>`);
            }
            return isMatch;
        },
        resetResult:function(){
            const {searchDataWrapper, searchResultTextContent, searchResultNotFoundContainer,searchResultNotFoundContent, searchShowContainer, searchPaginationContainer, searchResultFilter,searchResultFilterLabel,searchPaginationNext,searchPaginationPrev,searchKeyBox} = searchResult.variables;
            $(searchDataWrapper).empty();
            $(searchShowContainer).empty();
            $(searchPaginationContainer).empty();
            $(searchResultFilter).next(searchResultFilterLabel).find('.search__count').remove();
            $(searchPaginationNext).addClass('d-none');
            $(searchPaginationPrev).addClass('d-none');
            $(searchKeyBox).addClass('d-none');
            $(searchResultNotFoundContainer).addClass('d-none');
            $(searchResultTextContent).remove();

        },

        headerSearchKeywordHandler: function(){
                 let timeout;

                $('.global__search--input').on('keyup', function() {
                    const $this = $(this);
                    clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        let buttonText = $this.val();
                        let section = $this.closest('.global__search--input');
                        let titleText = section.find('.heading-2').text().trim();
                        let obj = searchResult.methods.dataLayerObj(buttonText, titleText);
                        createDataLayer('enter_search_keyword', obj);
                    }, 3000);
                });
            },
        dataLayerObj: function (e,el) {
              var obj = {
                  'articleName': "",
                  'blogCategory': "",
                  'blogPageCategory': "",
                  'buttonText': "",
                  'pageSection': el ? el : "Header Search",
                  'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
                  'planOption': "",
                  'productCategory': "",
                  'productName': "",
                  'question': "",
                  'source': "",
                  'searchTerm': e ? e : "",
                  'videoTitle': "",
                  'bannerName': "",
              };
              return obj;
            },
        init:function(){
            this.setFilterId();
            this.populateSearchText();
            this.searchOnInput();
            this.handleAutoSuggestBlur();
            this.searchInputFocus();
            this.submitSearchInput();
            this.handleAutoSuggestClick();
            this.handleSubmitBtn();
            this.handleChangeFilter();
        }
    },
};

$(()=>{
    const {searchWrapper} = searchResult.variables;
    if($(searchWrapper).length){
    searchResult.methods.init();
    }
    searchResult.methods.headerSearchKeywordHandler();
});
